import { atom } from 'recoil';

export const defaultState = {
  cartId: null,
  currency_code: 'SGD',
  products: {},
  country: null,
  loaded: false,
  failed_products: {}
};

export const cart = atom({
  key: 'cart',
  default: {
    ...defaultState
  }
});

export default cart;
